import Vue from 'vue'

import InvoiceTranformer from '@/transformers/purchase/invoice'
import moment from 'moment'

function urlParamsTransformer(options) {
  const from = options.from ? moment(options.from).format('YYYY/MM/DD'): null
  const to = options.to ? moment(options.to).format('YYYY/MM/DD'): null
  const search_text = !!options.searchQuery ? options.searchQuery : undefined
  return {
    page: options.page,
    size: options.pageSize,
    status: options.status,
    text: search_text,
    from,
    to,
  }
}

  export default (options) => {
    let urlParams
  
    urlParams = urlParamsTransformer(options)
      
  
    let url = `purchase/buy_order_invoice/`
  
    let config
  
    if (urlParams) {
      config  = {
        params: urlParams,
      }
    }
  
    return Vue.$http.get(url, config)
      .then(response => {
          const paginationInfo = {...response.data, results: null}
          const results = response.data.results
          const invoices = InvoiceTranformer.fetchCollection(results)
          return {invoices, paginationInfo}

      })
  }
  


// WEBPACK FOOTER //
// ./src/services/purchase/fetchInvoices.js